<template>
<div class="chapter">
<div class="inner_page">
<p class="to"><b>T</b><b><span class="small">ABLE OF</span></b> <b>C</b><b><span class="small">ONTENTS</span></b></p>
<p class="toc"><span href="#/Text/Alle_9781617750601_epub_c2_r1" title="Link target outside of Sample">Title Page</span></p>
<p class="toc"><span href="#/Text/Alle_9781617750601_epub_c3_r1" title="Link target outside of Sample">Copyright Page</span><br/>
</p>
<p class="toc"><a href="#/Text/Alle_9781617750601_epub_c8_r1"><i>Introduction</i></a></p>
<p class="toc"><a href="#/Text/Alle_9781617750601_epub_c9_r1"><b>PART I: COUNTRY</b></a></p>
<p class="toc"><a href="#/Text/Alle_9781617750601_epub_c10_r1"><b>L<span class="small">ISA</span> A<span class="small">LLEN</span>-A<span class="small">GOSTINI</span></b></a></p>
<p class="toc1">Sans Souci</p>
<p class="toc1"><i>Pot Luck</i></p>
<p class="toc"><a href="#/Text/Alle_9781617750601_epub_c11_r1"><b>K<span class="small">EVIN</span> B<span class="small">ALDEOSINGH</span></b></a></p>
<p class="toc1">Couva</p>
<p class="toc1"><i>The Rape</i></p>
<p class="toc"><span href="#/Text/Alle_9781617750601_epub_c12_r1" title="Link target outside of Sample"><b>S<span class="small">HANI</span> M<span class="small">OOTOO</span></b></span></p>
<p class="toc1">San Fernando</p>
<p class="toc1"><i>The Funeral Party</i></p>
<p class="toc"><span href="#/Text/Alle_9781617750601_epub_c13_r1" title="Link target outside of Sample"><b>R<span class="small">EENA</span> A<span class="small">NDREA</span> M<span class="small">ANICKCHAND</span></b></span></p>
<p class="toc1">Caroni Swamp</p>
<p class="toc1"><i>Dougla</i></p>
<p class="toc"><span href="#/Text/Alle_9781617750601_epub_c14_r1" title="Link target outside of Sample"><b>R<span class="small">AMABAI</span> E<span class="small">SPINET</span></b></span></p>
<p class="toc1">Santa Cruz</p>
<p class="toc1"><i>Nowarian Blues</i></p>
<p class="toc"><span href="#/Text/Alle_9781617750601_epub_c15_r1" title="Link target outside of Sample"><b>W<span class="small">ILLI</span> C<span class="small">HEN</span></b></span></p>
<p class="toc1">Godineau</p>
<p class="toc1"><i>Betrayal</i></p>
<p class="toc"><span href="#/Text/Alle_9781617750601_epub_c16_r1" title="Link target outside of Sample"><b>J<span class="small">AIME</span> L<span class="small">EE</span> L<span class="small">OY</span></b></span></p>
<p class="toc1">Palmiste</p>
<p class="toc1"><i>Bury Your Mother</i></p>
<p class="toc"><span href="#/Text/Alle_9781617750601_epub_c17_r1" title="Link target outside of Sample"><b>O<span class="small">ONYA</span> K<span class="small">EMPADOO</span></b></span></p>
<p class="toc1">Maracas</p>
<p class="toc1"><i>Standing on Thin Skin</i></p>
<p class="toc1"><a href="#/Text/Alle_9781617750601_epub_c9_r1"><b>PART II: TOWN</b></a></p>
<p class="toc"><span href="#/Text/Alle_9781617750601_epub_c19_r1" title="Link target outside of Sample"><b><span class="small">ELISHA EFUA BARTELS</span></b></span></p>
<p class="toc1">Diego Martin</p>
<p class="toc1"><i>Woman Is Boss</i></p>
<p class="toc"><span href="#/Text/Alle_9781617750601_epub_c20_r1" title="Link target outside of Sample"><b>L<span class="small">AWRENCE</span> S<span class="small">COTT</span></b></span></p>
<p class="toc1">Maraval</p>
<p class="toc1"><i>Prophet</i></p>
<p class="toc"><span href="#/Text/Alle_9781617750601_epub_c21_r1" title="Link target outside of Sample"><b>R<span class="small">OBERT</span> A<span class="small">NTONI</span></b></span></p>
<p class="toc1">Uptown Port-of-Spain</p>
<p class="toc1"><i>How to Make Photocopies in the Trinidad &amp; Tobago National Archives</i></p>
<p class="toc"><span href="#/Text/Alle_9781617750601_epub_c22_r1" title="Link target outside of Sample"><b>D<span class="small">ARBY</span> M<span class="small">ALONEY</span></b></span></p>
<p class="toc1">San Juan</p>
<p class="toc1"><i>The Best Laid Plans</i></p>
<p class="toc"><span href="#/Text/Alle_9781617750601_epub_c23_r1" title="Link target outside of Sample"><b>K<span class="small">EITH</span> J<span class="small">ARDIM</span></b></span></p>
<p class="toc1">Emperor Valley Zoo</p>
<p class="toc1"><i>The Jaguar</i></p>
<p class="toc"><span href="#/Text/Alle_9781617750601_epub_c24_r1" title="Link target outside of Sample"><b>R<span class="small">IAN</span> M<span class="small">ARIE</span> E<span class="small">XTAVOUR</span></b></span></p>
<p class="toc1">Tunapuna</p>
<p class="toc1"><i>Eric’s Turn</i></p>
<p class="toc"><span href="#/Text/Alle_9781617750601_epub_c25_r1" title="Link target outside of Sample"><b>E<span class="small">LIZABETH</span> N<span class="small">UNEZ</span></b></span></p>
<p class="toc1">St. James</p>
<p class="toc1"><i>Lucille</i></p>
<p class="toc"><span href="#/Text/Alle_9781617750601_epub_c26_r1" title="Link target outside of Sample"><b>V<span class="small">AHNI</span> C<span class="small">APILDEO</span></b></span></p>
<p class="toc1">Fort George</p>
<p class="toc1"><i>Peacock Blue</i></p>
<p class="toc"><span href="#/Text/Alle_9781617750601_epub_c27_r1" title="Link target outside of Sample"><b>J<span class="small">UDITH</span> T<span class="small">HEODORE</span></b></span></p>
<p class="toc1">East Dry River</p>
<p class="toc1"><i>Dark Nights</i></p>
<p class="toc"><span href="#/Text/Alle_9781617750601_epub_c28_r1" title="Link target outside of Sample"><b>T<span class="small">IPHANIE</span> Y<span class="small">ANIQUE</span></b></span></p>
<p class="toc1">Chaguaramas</p>
<p class="toc1"><i>Gita Pinky Manachandi</i></p>
<p class="toc1"><span href="#/Text/Alle_9781617750601_epub_c29_r1" title="Link target outside of Sample"><b>About the Contributors</b></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Alle_9781617750601_epub_c7_r1.vue?a963caa6